import React from 'react'
import { Select } from '@ztechapps/webui.input'
import { productTypeOptions } from './productTypeOptions'

export const ProductTypeSelect = ({ ...rest }) => {
  return (
    <Select
      isClearable={false}
      {...{
        ...rest,
        options: productTypeOptions,
      }}
    />
  )
}
